import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-green relative overflow-hidden" data-id="element-152">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-153">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-12 text-cream leading-tight" data-id="element-154">
          El próximo lunes podés seguir buscando. <br data-id="element-155" />
          <span className="text-gold" data-id="element-156">
            O podés entrar al taller con todo listo.
          </span>
        </h2>

        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-green-dark p-8 rounded-2xl border border-green-light/30" data-id="element-157">
          {['Buscando información dispersa en cuatro lugares distintos.', 'Armando una evaluación la noche anterior.', 'Explicando un proceso técnico sin los parámetros correctos a mano.', 'Terminando el año con la sensación de que los alumnos aprendieron temas sueltos pero nunca vieron el proceso completo.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-158">
              <span className="text-terracota mt-1" data-id="element-159">▸</span>
              <span className="text-cream-light" data-id="element-160">{item}</span>
            </div>)}
        </div>

        <p className="text-2xl font-bold text-gold mb-6" data-id="element-161">
          O podés elegir diferente.
        </p>

        <div className="text-cream-light text-lg space-y-4 mb-16 max-w-3xl mx-auto" data-id="element-162">
          <p data-id="element-163">
            El Mega Pack no te convierte en mejor docente.{' '}
            <strong className="text-cream" data-id="element-164">Vos ya sos un buen docente.</strong>
          </p>
          <p data-id="element-165">
            Lo que hace el Mega Pack es darte la estructura, las actividades,
            las evaluaciones y los proyectos para que eso se note en cada
            práctica de taller.
          </p>
          <p data-id="element-166">
            Te devuelve el tiempo que perdés planificando. Te da la seguridad de
            entrar al aula con todo preparado.
          </p>
          <p data-id="element-167">
            Les muestra a tus alumnos el proceso completo: de la materia prima
            al producto terminado, envasado y calculado.
          </p>
        </div>

        <div className="bg-cream rounded-3xl p-8 md:p-12 shadow-xl border border-gold/50 text-ink" data-id="element-168">
          <h3 className="text-2xl font-bold text-green mb-6 text-center border-b border-cream-dark pb-6" data-id="element-169">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-3 mb-10 text-left" data-id="element-170">
            {['Tomo 1 — Las Bases del Taller Profesional', 'Tomo 2 — De la Materia Prima a la Conservación', 'Tomo 3 — Tecnología de Lácteos y Cárnicos', 'Tomo 4 — Del Envase al Consumidor', 'Tomo 5 — Del Taller al Emprendimiento', 'Banco de paquete de actividades Adicionales', 'Banco de Evaluaciones', 'Recetario Técnico de Referencia', 'Proyectos Productivos Extra', 'Garantía de 7 días', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-171">
                <Check size={16} className="text-terracota shrink-0" data-id="element-172" />
                <span className="text-sm font-medium" data-id="element-173">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-174">
            <div className="mb-8 p-6 bg-warmwhite rounded-xl border border-cream-dark italic text-slate text-lg" data-id="element-175">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-176" />
              <span className="text-terracota font-bold not-italic" data-id="element-177">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-4xl font-bold text-green mb-2" data-id="element-178">USD 19,90</p>
            <p className="text-sm text-terracota font-medium mb-8" data-id="element-179">
              Precio promocional disponible por tiempo limitado
            </p>

            <Button href="#pricing" variant="terracota" className="mb-6 w-full sm:w-auto" data-id="element-180">
              QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-slate font-medium" data-id="element-181">
              <span data-id="element-182">✅ Garantía de 7 días</span>
              <span data-id="element-183">🔒 Pago seguro</span>
              <span data-id="element-184">⚡ Acceso inmediato</span>
              <span data-id="element-185">💱 Pagás en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}